import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { BetaFeature } from '@cdba/shared/constants/beta-feature';
import { BetaFeatureService } from '@cdba/shared/services/beta-feature/beta-feature.service';

@Component({
  selector: 'cdba-beta-feature-settings',
  templateUrl: './beta-feature-settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BetaFeatureSettingsComponent implements OnInit {
  private readonly dialog = inject(MatDialog);
  private readonly betaFeatureService = inject(BetaFeatureService);

  @ViewChild('highFiveDialog') highFiveDialogTemplate: TemplateRef<any>;

  disableToggles = false;
  private highFiveTimeout: number;
  private reloadPage: boolean;

  showPricingToggle = true;
  pricingActivated = false;

  ngOnInit(): void {
    this.pricingActivated = this.betaFeatureService.getBetaFeature(
      BetaFeature.PRICING
    );
  }

  onPricingToggleChange(matSlideToggleChange: MatSlideToggleChange): void {
    this.handleFeatureToggleChange(
      BetaFeature.PRICING,
      matSlideToggleChange.checked,
      true
    );
  }

  handleFeatureToggleChange(
    betaFeature: `${BetaFeature}`,
    betaFeatureState: boolean,
    reloadPage?: boolean
  ): void {
    let timeoutDelay = 500;

    this.reloadPage = reloadPage;
    this.betaFeatureService.setBetaFeature(betaFeature, betaFeatureState);
    this.disableToggles = true;

    if (betaFeatureState) {
      timeoutDelay = 5000;

      this.dialog.open(this.highFiveDialogTemplate, {
        backdropClass: ['!bg-surface-legacy', '!opacity-90'],
        panelClass: 'high-five-dialog',
      });
    }

    this.highFiveTimeout = globalThis.setTimeout(() => {
      this.handleSettingFinalization();
    }, timeoutDelay);
  }

  onHighFiveClick(): void {
    if (this.highFiveTimeout) {
      globalThis.clearTimeout(this.highFiveTimeout);
    }

    this.handleSettingFinalization();
  }

  private handleSettingFinalization(): void {
    this.disableToggles = false;
    this.dialog.closeAll();

    if (this.reloadPage) {
      location.reload();
    }
  }
}
